'use strict';
angular.module('productManageMentWeixinSubscriptionModifyModule', [])
    .controller('productManageMentWeixinSubscriptionModifyCtrl', ['$scope', '$modalInstance', 'modalDialog', 'item', 'trsHttpService', '$q', 'Upload', 'getFileMD5Service', function($scope, $modalInstance, modalDialog, item, trsHttpService, $q, Upload, getFileMD5Service) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.list = {
                // qieAccoutList: [{
                //     name: '请选择企鹅号',
                //     value: 0
                // }]
            };
            $scope.data = {
                selecteQieAccout: {}, // 选中的企鹅
            };
            // initQieAccout();
            $scope.isJudge = false;
            var params = {
                serviceid: 'mlf_wechatconfig',
                methodname: 'findChannelById',
                ChannelId: item.CHANNELID,
                TopChannelId: 0
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.list.forbidDays = data.REPEATUSETIME;
                $scope.list.CheckFgdAttribute = data.CHECKFGDATTRIBUTE;
                $scope.list.ISORIGINAL = data.ISORIGINAL;
                $scope.list.CHANNELDESCRIPTION = data.CHANNELDESCRIPTION;
                $scope.list.CHNLTABLE = data.CHNLTABLE;
                $scope.list.CODEURL = data.CODEURL;
                $scope.isJudge = data.ISORIGINAL == '1';
                $scope.list.ISPAICHONG = data.ISPAICHONG;
                $scope.list.CKMSIMDAYRANGE = data.CKMSIMDAYRANGE;
                $scope.list.KUAIBAOACCOUNTID = data.KUAIBAOACCOUNTID;
                $scope.data.selecteQieAccout.value = data.KUAIBAOACCOUNTID;
                $scope.data.selecteQieAccout.name = data.ACCOUNTNAME === '未绑定' ? '请选择企鹅号' : data.ACCOUNTNAME ;
                $scope.list.CHANNELICON = data.CHANNELICON;
            });
            
            getFileMD5Service.init();
        }

        /**
         * [initQieAccout description]
         * @return  {[type]}  [return description]
         */
        // function initQieAccout() {
        //     let accoutParams = {
        //         methodname: 'queryAccounts',
        //         serviceid: 'mlf_kuaibaoaccount',
        //     };
        //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), accoutParams, 'get').then((data) => {
        //         angular.forEach(data.DATA, function(item) {
        //             item.value = item.KUAIBAOACCOUNTID;
        //             item.name = item.ACCOUNTNAME;
        //         });
        //         $scope.list.qieAccoutList = $scope.list.qieAccoutList.concat(data.DATA);
        //     });
        // }
        $scope.queryByDropdown = function(value) {
            $scope.list.KUAIBAOACCOUNTID = value;
        };
        
        /**
         * [upload description]
         *
         * @param   {[type]}  $files     [$files description]
         * @param   {[type]}  $file      [$file description]
         * @param   {[type]}  $newFiles  [$newFiles description]
         *
         * @return  {[type]}             [return description]
         */
        $scope.upload = function($files, $file, $newFiles) {
            if (!$newFiles) {return;}
            getFileMD5Service.getMd5($newFiles[0]).then(function(md5) {
                upload($newFiles[0], md5); 
            });
        };

        /**
         * [upload description] 上传
         *
         * @param   {[type]}  file  [file description]
         * @param   {[type]}  md5   [md5 description]
         *
         * @return  {[type]}        [return description]
         */
        function upload(file, md5) {
            var defer = $q.defer();
            if (file.size === 0) {
                return;
            }
            $scope.loadingPromise = Upload.upload({
                url: '/wcm/openapi/uploadImage?md5=' + md5,
                data: {
                    file: file
                },
            }).then(function(resp) {
                var data = resp.data;
                if (data.error) {
                    modalDialog.alertType(data.error, '', 'error', false);
                } else {
                    $scope.list.CODEURL = data.imgSrc;
                    $scope.list.CHNLTABLE = data.imgName;
                    defer.resolve();
                }
            }, function(resp) {
                modalDialog.alertType('上传失败', '', 'error', false);
                defer.reject();
            }, function(evt) {
                defer.reject();
            });
            return defer.promise;
        }

        $scope.removeImg = function() {
            $scope.list.CHNLTABLE = '';
            $scope.list.CODEURL = '';
        };

        /**
         * [cancel description] 关闭弹窗
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [checkProperty description] 选择是否检查稿件属性
         * @return {[type]} [description]
         */
        $scope.checkProperty = function() {
            $scope.list.CheckFgdAttribute = $scope.list.CheckFgdAttribute === '1' ? '0' : '1';
        };

        /**
         * [isConfirm description] 保存弹窗
         * @return {Boolean} [description]
         */
        $scope.confirm = function() {
            var params = {
                serviceid: 'mlf_wechatconfig',
                methodname: 'saveNewChnl',
                CHNLNAME: item.CHNLNAME,
                CHNLDESC: item.CHNLDESC,
                OBJECTID: item.CHANNELID,
                TopChannelId: 0,
                PARENTID: 0,
                RepeatUseTime: $scope.list.forbidDays,
                CheckFgdAttribute: $scope.list.CheckFgdAttribute,
                ISORIGINAL: $scope.list.ISORIGINAL,
                CHANNELDESCRIPTION: $scope.list.CHANNELDESCRIPTION,
                CHNLTABLE: $scope.list.CHNLTABLE,
                CODEURL: $scope.list.CODEURL,
                ISPAICHONG: $scope.list.ISPAICHONG,
                CKMSIMDAYRANGE: $scope.list.CKMSIMDAYRANGE,
                KUAIBAOACCOUNTID: $scope.list.KUAIBAOACCOUNTID,
            };
            if ($scope.isJudge && $scope.list.ISORIGINAL == '0'){
                deleteProducts();
            }
            $modalInstance.close(params);
        };

        /**
         * [deleteProducts description]
         *
         * @return  {[type]}  [return description]
         */
        function deleteProducts(){
            let params = {
                serviceid: 'mlf_originalgroup',
                methodname: 'deleteProduct',
                PRODUCTID: item.CHANNELID,
                MEDIATYPE: 4
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data){

            });
        }
    }]);
